import { styled } from '@/src/stitches.config'
import Link from 'next/link'
import { changeProductEvent } from '@/src/common/utilities/gtag'

export const StyledText = styled('p', {
    fontSize: '1.1rem',
    marginBottom: 20,
})

interface ITextProps {
    linkToPlastic: boolean
    style?: object
}

const InterestedInText = ({ linkToPlastic, style = {} }: ITextProps) => {
    const url: string = linkToPlastic
        ? '/personalized-visa-gift-card'
        : '/virtual-visa-gift-cards'
    const type: string = linkToPlastic ? 'Plastic' : 'Virtual'

    return (
        <StyledText style={style}>
            Interested in{' '}
            <Link
                href={url}
                style={{ color: '#2C73FF' }}
                onClick={() => changeProductEvent(type.toLowerCase())}
            >
                Buying a {type} Visa?
            </Link>
        </StyledText>
    )
}

export default InterestedInText
